import { Table, Modal, Tag, List } from "antd";
import dayjs from "dayjs";

import { clamp } from "../../../../../utils/responsiveHelpers";

const QueryNotificationsTableModal = ({
  notificationsList = [],
  currentQueryPickupTimestamps = [],
  currentMentor = "",
  isModalOpen = false,
  setIsModalOpen = () => {}
}) => {
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const notificationsColumn = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Mentor",
      dataIndex: "mentor",
      key: "mentor"
    },
    {
      title: "Mentor Slab",
      dataIndex: "mentorSlab",
      key: "mentorSlab"
    },
    {
      title: "Thank points",
      dataIndex: "mentorThankPoints",
      key: "mentorThankPoints"
    },
    {
      title: "Ping Group",
      dataIndex: "pingGroup",
      key: "pingGroup"
    },
    {
      title: "Slab Algo Used",
      dataIndex: "isSlabAlgoUsed",
      key: "isSlabAlgoUsed"
    },
    {
      title: "Status",
      key: "status",
      render: (row) => {
        const statusMap = {
          PENDING: { color: "orange", label: "PENDING" },
          SENT: { color: "green", label: "SENT" }
        };

        // Get the status object based on the row status or default to 'open'
        const statusObj = statusMap[row.status] || { color: "gray", label: "Unknown" };

        return (
          <Tag color={statusObj.color} key={statusObj.label}>
            {statusObj.label.toUpperCase()}
          </Tag>
        );
      }
    },
    {
      title: "Scheduled For",
      dataIndex: "scheduledFor",
      key: "scheduledFor",
      render: (scheduledFor) =>
        scheduledFor ? dayjs(scheduledFor).format("DD MMM YYYY | HH:mm:ss") : "--"
    },
    {
      title: "Sent At",
      dataIndex: "sentAt",
      key: "sentAt",
      render: (sentAt) => (sentAt ? dayjs(sentAt).format("DD MMM YYYY | HH:mm:ss") : "--")
    },
    {
      title: "Message Deleted At",
      dataIndex: "messageDeletedAt",
      key: "messageDeletedAt",
      render: (messageDeletedAt) =>
        messageDeletedAt ? dayjs(messageDeletedAt).format("DD MMM YYYY | HH:mm:ss") : "--"
    }
  ];

  return (
    <Modal
      title="Query Notifications"
      open={isModalOpen}
      footer={[]}
      width={2500}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <div
        style={{
          marginTop: "20px",
          marginLeft: clamp(12, 30),
          marginRight: clamp(12, 30)
        }}
      >
        <div>Current Mentor: {currentMentor}</div>
        <List
          header={<div>Query Pickup Timestamps</div>}
          bordered
          dataSource={currentQueryPickupTimestamps || []}
          renderItem={(item) => (
            <List.Item>{item ? dayjs(item).format("DD MMM YYYY | HH:mm:ss") : "--"}</List.Item>
          )}
        />
        <br />
        <Table
          columns={notificationsColumn}
          dataSource={notificationsList}
          bordered
          pagination={false}
          scroll={{ x: "max-content" }}
        />
      </div>
    </Modal>
  );
};

export default QueryNotificationsTableModal;
